<template>
  <div class="table">
    <div class="container">
      <el-row>
        <el-button size="mini" class="btn" type="primary" v-acl="ApplyCreateApply,ApplyUpdate" @click="saveQuotationApply()" v-show="saveBtnShow">{{$t('common.save')}}</el-button>
        <!--保存-->
        <el-button size="mini" class="btn" type="primary" v-acl="ApplySubmitApply" @click="submitQuotationApply" v-show="submitBtnShow">{{$t('common.submit')}}</el-button>
        <!--提交-->
        <el-button size="mini" class="btn" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </el-row>
      <div class="handle-box">
        <el-form :model="applyData" :label-position="labelPosition" :rules="applyRules" ref="applyInfoForm" label-width="140px">
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('apply.no')">
                <!--单据编号-->
                <el-input class="handle-input" v-model="applyData.applyNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('apply.applyType')" prop="applyType">
                <!--类型-->
                <el-select v-model="applyData.applyType" :disabled="true" class="handle-input">
                  <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="17">
              <el-form-item :label="$t('apply.subject')" prop="subject">
                <!--主题-->
                <el-input class="handle-input" v-model="applyData.subject" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('apply.shortlistedSuppliers')" prop="supplierNames">
                <!--入围供应商-->
                <el-input @click.native="showSelSupplierDialog=disableEditor==false?true:false" class="handle-input" :readonly="true" :disabled="disableEditor" suffix-icon="el-icon-search" v-model="applyData.supplierNames"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                <!--报价类型-->
                <el-select v-model="applyData.quotationType" class="handle-input" :disabled="disableEditor">
                  <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('common.createBy')">
                <!--创建人-->
                <el-input class="handle-input" v-model="applyData.name" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('common.createDate')">
                <!--创建日期-->
                <el-input class="handle-input" v-model="applyData.createDate" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('apply.lineDetail')" name="line">
          <el-row type="flex" justify="start" align="middle" style="margin-bottom: 10px">
            <el-button size="mini" class="btn" type="primary" v-show="applyLineEdit" v-acl="ApplyCreateApplyLine" @click="showApplyLineAddDialogFunc">{{$t('common.addNew')}}</el-button>
            <el-button size="mini" class="btn" type="danger" v-show="applyLineEdit" v-acl="ApplyDeleteApplyLine" @click="delSelQuotationApplyLine">{{$t('common.del')}}</el-button>
            <el-upload :on-error="importDetailError" :on-success="importDetailSuccess" :before-upload="beforeUpload" :show-file-list="false" class="apply-import-button" v-show="applyLineEdit" v-acl="ApplyDeleteApplyLine" :action="importDetailUrl" multiple="false" :headers="headers">
              <el-button size="mini" type="primary">{{$t('common.import')}}</el-button>
            </el-upload>
            <el-button size="mini" class="btn" type="primary" v-if="ttQuotationApplyId!==-99999" v-acl="ApplyCreateApplyLine" @click="onExport" style="margin-left:10px">{{$t('common.export')}}</el-button>
            <el-link v-show="applyLineEdit" v-acl="ApplyDeleteApplyLine" type="button" target="_blank" href="static/template/RFQ(Line)Template.xlsx" download="RFQ(Line)Template.xlsx">
              <el-button size="mini" type="primary">{{$t('common.templateDownload')}}</el-button>
            </el-link>
          </el-row>
          <ux-grid v-if="!lineChangeApplyFlag" ref="applyLineTableDataRef" :data="applyLineTableData" keep-source max-height="450" highlight-current-row show-overflow="tooltip">
            <ux-table-column align="center" type="checkbox" width="80" />
            <ux-table-column align="center" title="操作" width="80" v-show="!disableEditor">
              <template v-slot="scope">
                <i class="el-icon-edit-outline" @click="onEdit(scope)"></i>
              </template>
            </ux-table-column>
            <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
            <ux-table-column field="pickupPoint" :title="$t('base.pp.pickupPoint')" resizable align="center" sortable>
              <!-- <template v-slot="scope">
                {{scope.row.tmPickupId | ic('BASE','PICKUP_POINT')}}
              </template> -->
            </ux-table-column>
            <ux-table-column field="dcName" :title="$t('apply.dc')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.tmDcId | ic("BASE",'DC')}}
              </template>
            </ux-table-column>
            <ux-table-column field="temperature" :title="$t('apply.temperature')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.temperature | ic("COMMON",'TEMPERATURE')}}
              </template>
            </ux-table-column>
            <ux-table-column field="transportaionMethod" :title="$t('apply.transportaionMethod')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
              </template>
            </ux-table-column>
            <ux-table-column field="unit" :title="$t('apply.unit')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.unit | ic("COMMON",'UNIT')}}
              </template>
            </ux-table-column>
            <ux-table-column field="effectiveBeginDate" :title="$t('apply.effectiveBeginDate')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
              </template>
            </ux-table-column>
            <ux-table-column field="lineType" :title="$t('apply.lineType')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.lineType | ic("TT_QUOTATION_APPLY_LINE",'LINE_TYPE')}}
              </template>
            </ux-table-column>
            <ux-table-column field="remarks" :title="$t('common.remarks')" resizable align="center" sortable></ux-table-column>
          </ux-grid>
          <!--线路变更明细-->
          <ux-grid v-else ref="applyLineTableDataRef1" :data="applyLineTableData" max-height="450" keep-source show-overflow="tooltip">
            <ux-table-column align="center" title="操作" width="80" v-show="!disableEditor">
              <template v-slot="scope">
                <i class="el-icon-edit-outline" @click="onEdit1(scope)"></i>
              </template>
            </ux-table-column>
            <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
            <ux-table-column field="pickupPoint" :title="$t('base.pp.pickupPoint')" resizable align="center" sortable></ux-table-column>
            <ux-table-column field="dcName" :title="$t('apply.dc')" resizable align="center" sortable></ux-table-column>
            <ux-table-column field="temperature" :title="$t('apply.temperature')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.temperature | ic("COMMON",'TEMPERATURE')}}
              </template>
            </ux-table-column>
            <ux-table-column field="transportaionMethod" :title="$t('apply.transportaionMethod')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
              </template>
            </ux-table-column>
            <ux-table-column field="originalSupplierName" :title="$t('apply.originalSupplier')" resizable align="center" sortable></ux-table-column>
            <ux-table-column field="originalPrice" :title="$t('apply.originalPrice')" resizable align="center" sortable></ux-table-column>
            <ux-table-column field="unit" :title="$t('apply.unit')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.unit | ic("COMMON",'UNIT')}}
              </template>
            </ux-table-column>
            <ux-table-column field="effectiveBeginDate" :title="$t('apply.effectiveBeginDate')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
              </template>
            </ux-table-column>
            <ux-table-column field="lineType" :title="$t('apply.lineType')" resizable align="center" sortable>
              <template v-slot="scope">
                {{scope.row.lineType|ic('TT_QUOTATION_APPLY_LINE','LINE_TYPE')}}
              </template>
            </ux-table-column>
            <ux-table-column field="remarks" :title="$t('common.remarks')" resizable align="center" sortable></ux-table-column>
          </ux-grid>

        </el-tab-pane>
        <!--附件列表-->
        <el-tab-pane :label="$t('common.attachment')" name="enclosure">
          <!--附件-->
          <el-upload v-show="showUploadFlag" style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
            <el-button size="mini" slot="trigger" type="primary">{{$t('common.selectFile')}}</el-button>
            <!--选取文件-->
          </el-upload>
          <el-table :data="fileList" border highlight-current-row class="table">
            <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
              <!--文件-->
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
              </template>
            </el-table-column>
            <el-table-column sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
            <!--创建人-->
            <el-table-column sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
              <!--创建时间-->
              <template slot-scope="scope">
                {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
              </template>
            </el-table-column>

            <el-table-column v-if="showUploadFlag" prop="tmDocumentId" min-width="130px">
              <template slot-scope="scope">
                <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link>
                <!--删除-->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!--附件列表-->
      </el-tabs>

      <!--入围供应商选择-->
      <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
        <SelSupplier ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
      </el-dialog>
      <!--提货点选择-->
      <el-dialog :visible.sync="showSelPickupPointDialog" append-to-body width="80%">
        <SelPickupPoint ref="selPickupPointRef" @subCallMethod="selectPickupPointMethod"></SelPickupPoint>
      </el-dialog>
      <!--到货仓库选择-->
      <el-dialog :visible.sync="showSelDcDialog" append-to-body width="80%">
        <SelDc ref="selectDcRef" :showFlag="showSelDcDialog" :multipleSelectionFlag="true" @subCallMethod="selectDcMethod"></SelDc>
      </el-dialog>
      <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="80%">
        <SelDc ref="selectDcMultipleRef" :multipleSelectionFlag="false" @subCallMethod="selectDcMethod"></SelDc>
      </el-dialog>

      <!--申请单明细创建-->
      <el-dialog :title="$t('apply.detailCreate')" :close-on-click-modal="false" :visible.sync="showApplyLineAddDialog" width="600px">
        <el-form :model="applyLineNew" ref="aplyLineNewForm" class="form_border lineClass" :rules="applyLineNewRules" :label-position="labelPosition" label-width="130px">
          <el-row type="flex" justify="space-around">
            <el-col :span="16">
              <!--提货点-->
              <el-form-item clss="redSpan" :label="$t('base.pp.pickupPoint')" placeholder="" prop="pickupPoint">
                <el-input @click.native="showSelPickupPointDialogFunc()" v-model="applyLineNew.pickupPoint" class="handle-input ABC" suffix-icon="el-icon-search" />
              </el-form-item>
              <!-- 到货仓库（DC） -->
              <el-form-item clss="redSpan" label="DC" placeholder="" prop="dcName">
                <el-input @click.native="showSelDcDialogFunc('2')" v-model="applyLineNew.dcName" class="handle-input" suffix-icon="el-icon-search" :readonly="true" />
              </el-form-item>
              <!--温区-->
              <el-form-item :label="$t('apply.temperature')" placeholder="" prop="temperature">
                <el-select v-model="applyLineNew.temperature" class="handle-input">
                  <el-option :key="index" v-for="(item,index) in temperatureList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
              <!--有效开始时间-->
              <el-form-item :label="$t('apply.effectiveBeginDate')" placeholder="">
                <el-date-picker class="handle-input" value-format="yyyy-MM-dd" v-model="applyLineNew.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button size="mini" type="primary" @click="createApplyLineNew">{{$t('common.confirm')}}</el-button>
          <el-button size="mini" type="primary" @click="showApplyLineAddDialog = false">{{$t('common.cancel')}}</el-button>
        </div>
      </el-dialog>

      <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
        <el-table min-height="450" :data="tableData" ref="tableDataRef" border highlight-current-row class="table">
          <el-table-column sortable prop="tmPickupId" :label="$t('base.pp.pickupPoint')">
            <template slot-scope="scope">
              <el-input @focus="showSelPickupPointDialogFunc(scope.row)" suffix-icon="el-icon-search" v-model="scope.row.pickupPoint"></el-input>
            </template>
          </el-table-column>
          <el-table-column sortable prop="tmDcId" :label="$t('apply.dc')">
            <template slot-scope="scope">
              <el-input @focus="showSelDcDialogFunc('1',scope.row)" suffix-icon="el-icon-search" v-model="scope.row.dcName"></el-input>
            </template>
          </el-table-column>
          <el-table-column sortable prop="temperature" :label="$t('apply.temperature')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.temperature" class="handle-input">
                <el-option :key="index" v-for="(item,index) in temperatureList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column sortable prop="transportaionMethod" :label="$t('apply.transportaionMethod')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.transportaionMethod" class="handle-input">
                <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column sortable prop="unit" :label="$t('apply.unit')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.unit" class="handle-input">
                <el-option :key="index" v-for="(item,index) in unitList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column sortable min-width="200px" prop="effectiveBeginDate" :label="$t('apply.effectiveBeginDate')">
            <template slot-scope="scope">
              <el-date-picker style="width: 80%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column sortable prop="lineType" :label="$t('apply.lineType')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.lineType" class="handle-input">
                <el-option :key="index" v-for="(item,index) in lineTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column sortable prop="remarks" :label="$t('common.remarks')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarks"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px;">
          <el-button type="primary" @click="onConfirm">确认</el-button>
          <el-button type="primary" @click="onCancel">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="报价明细" :visible.sync="dialogEditVisible1" width="80%" @close="onCancel1">
        <el-table :data="tableData1" ref="tableDataRef1" border highlight-current-row class="table">
          <el-table-column sortable prop="pickupPoint" :label="$t('base.pp.pickupPoint')"></el-table-column>
          <el-table-column sortable prop="tmDcId" :label="$t('apply.dc')"></el-table-column>
          <el-table-column sortable prop="temperature" :label="$t('apply.temperature')"></el-table-column>
          <el-table-column sortable prop="transportaionMethod" :label="$t('apply.transportaionMethod')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="originalSupplierName" :label="$t('apply.originalSupplier')" min-width="160"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="originalPrice" :label="$t('apply.originalPrice')"></el-table-column>
          <el-table-column sortable prop="unit" :label="$t('apply.unit')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.unit" class="handle-input">
                <el-option :key="index" v-for="(item,index) in unitList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column sortable min-width="200px" prop="effectiveBeginDate" :label="$t('apply.effectiveBeginDate')">
            <template slot-scope="scope">
              <el-date-picker :picker-options="dateLimit" style="width: 80%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column sortable prop="lineType" :label="$t('apply.lineType')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.lineType" class="handle-input">
                <el-option :key="index" v-for="(item,index) in lineTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column sortable prop="remarks" :label="$t('common.remarks')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarks"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px;">
          <el-button type="primary" @click="onCancel1">取消</el-button>
          <el-button type="primary" @click="onConfirm1">确认</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import { applyService } from "../../../api/quotation-apply/quotation-apply";
import { fileService } from "../../../api/common/file-utils";
import { inputChoiceService } from "../../../api/common/input-choice";
//入围供应商
import SelSupplier from '../base-data/carrier-sel-page'
//提货点选择
import SelPickupPoint from '../base-data/pickup-point-sel'
//到货仓库选择
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import commonConstants from "@/constants/commonConstants";
let checkSubject = (rule, value, callback) => {
  if (!value) {
      callback(new Error('请填写主题'))
  } else {
    if (value&&commonFun.unicodeLength(value) > 500) {
      callback(new Error('主题内容长度为500,请精简输入'))
    } else {
      callback()
    }
  }
}
export default {
  name: 'apply-detaill',
  components: {
    SelSupplier, SelPickupPoint, SelDc
  },
  computed: {
    importDetailUrl() {
      return commonConstants.baseUrl + `apply/importDetail/${this.ttQuotationApplyId}`;
    },
    headers() {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    },
    baseUrl() {
      return commonConstants.baseUrl;
    }
  },
  data() {
    return {
      columns: [
        { prop: "pickupPoint", label: this.$t('base.pp.pickupPoint') },
        { prop: "dcName", label: this.$t('apply.dc') },
        { prop: "temperature", label: this.$t('apply.temperature') },
        { prop: "transportaionMethod", label: this.$t('apply.transportaionMethod') },
        { prop: "unit", label: this.$t('apply.unit') },
        { prop: "effectiveBeginDate", label: this.$t('apply.effectiveBeginDate') },
        { prop: "lineType", label: this.$t('apply.lineType') },
        { prop: "remarks", label: this.$t('common.remarks') },
      ],
      columns1: [
        { prop: "pickupPoint", label: this.$t('base.pp.pickupPoint') },
        { prop: "dcName", label: this.$t('apply.dc') },
        { prop: "temperature", label: this.$t('apply.temperature') },
        { prop: "transportaionMethod", label: this.$t('apply.transportaionMethod') },
        { prop: "originalSupplierName", label: this.$t('apply.originalSupplier') },
        { prop: "originalPrice", label: this.$t('apply.originalPrice') },
        { prop: "unit", label: this.$t('apply.unit') },
        { prop: "effectiveBeginDate", label: this.$t('apply.effectiveBeginDate') },
        { prop: "lineType", label: this.$t('apply.lineType') },
        { prop: "remarks", label: this.$t('common.remarks') },
      ],
      ttQuotationApplyId: null,
      labelPosition: 'right',
      applyData: {},
      activeName: 'line',
      applyLineTableData: [],
      //changeApplyLineTableData:[],
      lineChangeApplyFlag: false,
      applyTypeList: [],
      quotationTypeList: [],
      temperatureList: [],
      transportaionMethodList: [],
      lineTypeList: [],
      unitList: [],
      saveBtnShow: false,
      submitBtnShow: false,
      applyLineEdit: false,
      showSelSupplierDialog: false,
      showApplyLineAddDialog: false,
      showSelPickupPointDialog: false,
      showSelDcDialog: false,
      showSelDcMultipleDialog: false,
      multipleSelectionBl: true,
      showUploadFlag: false,
      tempRows: null,
      applyLineNew: {},
      applyRules: {
        applyType: [
          //请选择申请单类型
          { required: true, message: this.$t('apply.selectApplyType'), trigger: 'blur' }
        ],
        supplierNames: [
          //请选择入围供应商
          { required: true, message: this.$t('apply.selectSuppliers'), trigger: 'dbclick' }
        ],
        quotationType: [
          //请选择报价类型
          { required: true, message: this.$t('apply.selectQuotationType'), trigger: 'blur' }
        ],
        subject: [
          { validator: checkSubject,trigger: 'blur' }
        ],
      },
      applyLineNewRules: {
        temperature: [
          { required: true, message: '', trigger: 'dbclick' }
        ],
        pickupPoint: [
          { required: true, message: '', trigger: 'dbclick' }
        ],
        dcName: [
          { required: true, message: '', trigger: 'dbclick' }
        ]
      },
      supplierIds: [],
      comeFrom: '',
      fileList: [],
      disableEditor: true,
      applyType: '',
      applyCreateDate: null,
      dateLimit: {},
      dialogEditVisible: false,
      dialogEditVisible1: false,
      index: null,
      index1: null,
      tableData: [],
      tableData1: [],
      loadingInstance: null,
    }
  },
  created() {
    this.ttQuotationApplyId = this.$route.params.applyId;
    this.comeFrom = this.$route.params.source;
    this.applyType = this.$route.params.applyType;
    if (this.$route.params.applyType == '2') {
      this.lineChangeApplyFlag = true;
    }
    //接收参数获取后台数据
    this.applyPageInit(this.$route.params.applyId);
    this.getInputChoiceValues();
    this.getFiles();
  },
  watch: {
    applyCreateDate(newTime, oldTime) {
      let _this = this;
      let createDateString = _this.applyCreateDate;
      this.dateLimit = {
        disabledDate(time) {
          let str = createDateString.replace(/-/g, '/');
          let date = new Date(str);
          date.setMonth(date.getMonth() + 1)
          date.setDate(1);
          return time.getTime() < date;//- 8.64e7; // - 8.64e7 表示可选择当天时间
        }
      }
    }
  },
  methods: {
    // 新增线路编辑
    onEdit(scope) {
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.tableData.push(JSON.parse(JSON.stringify(scope.row)))
    },
    onConfirm() {
      console.log('this.tableData[0]', this.tableData[0]);
      this.$refs.applyLineTableDataRef.reloadRow(this.$refs.applyLineTableDataRef.data[this.index], this.tableData[0], null)
      console.log('this.$refs.applyLineTableDataRef.data[this.index]', this.$refs.applyLineTableDataRef.data);
      this.dialogEditVisible = false
      setTimeout(() => {
        this.tableData = []
      }, 500);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.tableData = []
    },
    // 线路变更编辑
    onEdit1(scope) {
      this.dialogEditVisible1 = true
      this.index1 = scope.rowIndex
      this.tableData1.push(JSON.parse(JSON.stringify(scope.row)))
    },

    onConfirm1() {
      this.$refs.applyLineTableDataRef1.reloadRow(this.$refs.applyLineTableDataRef1.data[this.index], this.$refs.tableDataRef1.data[0], null)
      this.dialogEditVisible1 = false
      setTimeout(() => {
        this.tableData1 = []
      }, 500);
    },
    onCancel1() {
      this.dialogEditVisible1 = false
      this.tableData1 = []
    },
    onExport() {
      applyService.exportDetail(this.ttQuotationApplyId).then((res) => {
        fileService.respToFile(res, '线路报价申请单' + this.applyData.applyNo + '.xlsx');
      })
    },
    selectInit(row, index) {
      if (this.applyLineEdit) {
        return true
      } else {
        return false
      }
    },
    //文件下载
    downloadFile(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件删除
    deleteFile(tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //文件列表数据获取
    getFiles() {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.ttQuotationApplyId;
        attachment.tsReckindId = 'QUOTATION_APPLY';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    historyBack() {
      if (this.comeFrom == 'quotation') {
        this.$router.replace({
          path: '/quotation'
        });
      } else if (this.comeFrom == 'apply') {
        this.$router.replace({
          path: '/apply'
        });
      } else if (this.comeFrom == 'sourcing') {
        this.$router.replace({
          path: '/sourcing'
        });
      } else {
        this.$router.go(-1);
      }
    },
    //页面初始化
    applyPageInit(applyId) {
      applyService.getQuotationApplyInfo(applyId).then((res) => {
        this.applyData = res.quotationApply;
        this.applyCreateDate = this.applyData.createDate;
        this.supplierIds = res.quotationApply.supplierIds;
        //非供应商端只能编辑代供应商的单据
        if (!!res.quotationApply.ttQuotationApplyId && res.quotationApply.status == '1' && res.quotationApply.source == 'MCD' && res.ownerFlag == true) {
          //草稿单据
          this.submitBtnShow = true;
          this.saveBtnShow = true;
          this.applyLineEdit = true;
          this.showUploadFlag = true;
          this.disableEditor = false;
          //如果是线路变更申请单
          if (res.quotationApply.applyType == '2') {
            this.applyLineEdit = false;
          }
        } else if (this.ttQuotationApplyId <= 0) {
          //新增线路申请单MCD
          this.saveBtnShow = true;
          this.disableEditor = false;
        }
        if (res.quotationApplyLine) {
          this.applyLineTableData = res.quotationApplyLine;
          if (this.$route.params.applyType == '2') {
            this.$refs.applyLineTableDataRef1.reloadData(res.quotationApplyLine)
          } else {
            this.$refs.applyLineTableDataRef.reloadData(res.quotationApplyLine)
          }
        }
      });
    },
    //线路报价保存
    saveQuotationApply() {
      //判断校验是否通过
      let validFlag = false;
      this.$refs['applyInfoForm'].validate((valid) => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      let dcPP = this.validateApplyLineTableData(this.applyLineTableData);
      if (!dcPP) {
        // Message({ message: '申请单明细必须维护提货点与到货仓库！', type: "error" });
        this.$my_message('申请单明细必须维护提货点与到货仓库！', 'error')
        return;
      }
      if (!!this.ttQuotationApplyId && this.ttQuotationApplyId > 0) {
        let quotationApplyInfo = {};
        quotationApplyInfo.quotationApply = this.applyData;
        quotationApplyInfo.quotationApplyLine = this.applyLineTableData;
        // let flag = false;
        // this.applyLineTableData.forEach(item => {
        //   if (!item.unit) {
        //     //请填写结算单位
        //     Message({ message: this.$t('apply.fillForUnit'), type: "warning" });
        //     flag = true;
        //   }
        //   if (!item.effectiveBeginDate) {
        //     //请选择有效开始日期
        //     Message({ message: this.$t('apply.fillForEffectiveBeginDate'), type: "warning" });
        //     flag = true;
        //   }
        // })
        // if (flag) {
        //   return;
        // }
        //修改
        applyService.updateApplyInfo(quotationApplyInfo).then((res) => {
          // Message({ message: this.$t('common.saveSuccess'), type: "success" });
          this.$my_message(this.$t('common.saveSuccess'), 'success')
        })
      } else {
        //新增
        applyService.createApplyInfo(this.applyData).then((res) => {
          if (res.meta.success) {
            this.ttQuotationApplyId = res.data;
            //重新进行页面初始化
            this.applyPageInit(res.data)
          }
        })
      }

    },
    //线路报价申请单提交
    submitQuotationApply() {
      let _this = this;
      if (!!this.ttQuotationApplyId) {
        let dcPP = this.validateApplyLineTableData(this.applyLineTableData);
        if (!dcPP) {
          // Message({ message: '申请单明细必须维护提货点与到货仓库！', type: "error" });
          this.$my_message('申请单明细必须维护提货点与到货仓库！', 'error')
          return;
        }
        //判断校验是否通过
        let validFlag = false;
        _this.$refs['applyInfoForm'].validate((valid) => {
          validFlag = valid;
        });
        if (!validFlag) {
          return;
        }
        _this.$confirm(this.$t("common.sureSubmit"), this.$t("common.tips"), {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            let quotationApplyInfo = {};
            quotationApplyInfo.quotationApply = this.applyData;
            quotationApplyInfo.quotationApplyLine = this.applyLineTableData;
            let flag = false;
            this.applyLineTableData.forEach(item => {
              if (!item.unit) {
                //请填写结算单位
                // Message({ message: this.$t('apply.fillForUnit'), type: "warning" });
                this.$my_message(this.$t('apply.fillForUnit'), 'warning')
                flag = true;
              }
              if (!item.effectiveBeginDate) {
                //请选择有效开始日期
                // Message({ message: this.$t('apply.fillForEffectiveBeginDate'), type: "warning" });
                this.$my_message(this.$t('apply.fillForEffectiveBeginDate'), 'warning')
                flag = true;
              }
              if (!item.lineType) {
                // Message({ message: '请选择线路类型', type: "warning" });
                this.$my_message('请选择线路类型', 'warning')
                flag = true;
              }
            })
            if (flag) {
              return;
            }
            _this.submitBtnShow = false;
            //先进行修改
            applyService.updateApplyInfo(quotationApplyInfo).then((res) => {
              //修改成功后进行提交
              let mapObj = {};
              mapObj["applyId"] = this.ttQuotationApplyId;
              mapObj["confirm"] = 0;
              applyService.submitApplyInfo(mapObj).then((res) => {
                if (res.meta.success) {
                  Message({ message: this.$t('common.submitSuccess'), type: "success" });
                  _this.historyBack();
                } else {
                  _this.$confirm(res.meta.msg, this.$t('common.tips'), {
                    confirmButtonText: this.$t('common.confirm'),
                    cancelButtonText: this.$t('common.cancel'),
                    cancelButtonClass: 'el-button--primary',
                    confirmButtonClass: 'el-button--primary',
                    type: 'warning'
                  }).then(() => {
                    //用户确认后再次提交
                    mapObj["confirm"] = 1;
                    applyService.submitApplyInfo(mapObj).then(res => {
                      Message({ message: this.$t('common.submitSuccess'), type: "success" });
                      _this.historyBack();
                    }).catch(() => {
                      _this.submitBtnShow = true;
                    });
                  }).catch(() => {
                    _this.submitBtnShow = true;
                  });
                }
              }).catch(() => {
                _this.submitBtnShow = true;
              });

            })
          })
          .catch(() => {
          });

      }

    },
    //申请单条目创建
    createApplyLineNew() {
      if (!this.applyLineNew.tmPickupId) {
        //请选择提货点
        // Message({ message: this.$t('apply.selectPickupPoint'), type: "warning" });
        this.$my_message(this.$t('apply.selectPickupPoint'), 'warning')
        return;
      }
      if (!this.applyLineNew.dcName) {
        //请选择到货仓库
        // Message({ message: this.$t('apply.selectDcName'), type: "warning" });
        this.$my_message(this.$t('apply.selectDcName'), 'warning')
        return;
      }
      if (!this.applyLineNew.temperature) {
        //请选择温区
        // Message({ message: this.$t('apply.selectTemperature'), type: "warning" });
        this.$my_message(this.$t('apply.selectTemperature'), 'warning')
        return;
      }

      this.applyLineNew.ttQuotationApplyId = this.ttQuotationApplyId;
      applyService.createApplyLine(this.applyLineNew).then((res) => {
        if (res.meta.success) {
          // Message({ message: this.$t('common.saveSuccess'), type: "success" });
          this.$my_message(this.$t('common.saveSuccess'), 'success')
          this.applyPageInit(this.ttQuotationApplyId);
          this.showApplyLineAddDialog = false;
        }
      })
    },
    //线路报价条目删除
    delSelQuotationApplyLine() {
      let rows = this.$refs.applyLineTableDataRef.getCheckboxRecords();
      if (rows.length == 0) {
        //请选择需要删除的明细
        this.$my_message(this.$t('apply.selectDelLine'), 'warning')
      } else {
        let ids = [];
        rows.forEach((item) => {
          ids.push(item.ttQuotationApplyLineId)
        });
        applyService.delSelQuotationApplyLine(this.ttQuotationApplyId, ids).then((res) => {
          if (res.meta.success) {
            this.$my_message(this.$t('common.delSuccess'), 'success')
            this.applyLineTableData = res.data;
          } else {
            this.$my_message(this.$t('common.delError'), 'error')
          }
        });

      }
    },
    //供应商选择
    selectSupplierMethod(supList) {
      let _this = this;
      let codes = new Array();
      this.supplierIds = [];
      supList.forEach(((item) => {
        _this.supplierIds.push(item.tmSupplierId);
        codes.push(item.supplierName);
      }))
      _this.applyData.supplierNames = codes.join(",");
      _this.applyData.supplierIds = _this.supplierIds;
      this.showSelSupplierDialog = false;
    },
    //提货点选择
    selectPickupPointMethod(pickupPoint) {
      if (!!this.tempRows) {
        this.tempRows.pickupPoint = pickupPoint.pickupPoint;
        this.tempRows.tmPickupId = pickupPoint.tmPickupPointId;
      } else {
        this.applyLineNew.pickupPoint = pickupPoint.pickupPoint;
        this.applyLineNew.tmPickupId = pickupPoint.tmPickupPointId;
      }
      this.showSelPickupPointDialog = false;
    },
    //到货仓库选择
    selectDcMethod(dcList) {
      let _this = this;
      if (this.multipleSelectionBl) {//多选
        let codes = new Array();
        let dcIds = new Array();
        dcList.forEach(((item) => {
          dcIds.push(item.tmDcId);
          codes.push(item.dcName);
        }))
        _this.applyLineNew.dcName = codes.join(",");
        _this.applyLineNew.dcIds = dcIds;
      } else {//单选
        this.tempRows.tmDcId = dcList[0].tmDcId;
        this.tempRows.dcName = dcList[0].dcName;
      }
      this.showSelDcDialog = false;
      this.showSelDcMultipleDialog = false;
    },
    //线路报价申请单新增页面
    showApplyLineAddDialogFunc() {
      this.clearVlidate("aplyLineNewForm");
      this.applyLineNew = {};
      this.showApplyLineAddDialog = true;
    },
    showSelPickupPointDialogFunc(row) {
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      this.showSelPickupPointDialog = true;
      if (this.$refs.selPickupPointRef != undefined) {
        this.$refs.selPickupPointRef.cancelSeleted();
      }
    },
    showSelDcDialogFunc(method, row) {
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      if ('1' == method) {//单选
        this.multipleSelectionBl = false;
        this.showSelDcMultipleDialog = true;
      } else {
        this.multipleSelectionBl = true;
        this.showSelDcDialog = true;
      }
    },
    //下拉列表数据获取
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["COMMON:TEMPERATURE"] = "COMMON:TEMPERATURE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      mapObj["COMMON:UNIT"] = "COMMON:UNIT";
      mapObj["TT_QUOTATION_APPLY_LINE:LINE_TYPE"] = "TT_QUOTATION_APPLY_LINE:LINE_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.temperatureList = res["COMMON:TEMPERATURE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
        this.unitList = res["COMMON:UNIT"];
        this.lineTypeList = res["TT_QUOTATION_APPLY_LINE:LINE_TYPE"];
      });
    },
    //清除校验信息
    clearVlidate(refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    beforeUpload(file) {
      this.loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    importDetailSuccess(resp) {
      console.log('resp', resp);
      if (resp.meta.code === 200) {
        this.loadingInstance.close();
        this.$message.success('导入完成,已导入数据' + resp.data + '条')
        this.applyPageInit(this.ttQuotationApplyId);
      } else {
        this.$message.error(res.meta.msg)
      }
    },
    importDetailError(resp) {
      this.loadingInstance.close();
      Message.error(JSON.parse(resp.message).msg);
    },
    validateApplyLineTableData(applyLineTableData) {
      let returnFlag = true;
      if (!!applyLineTableData) {
        applyLineTableData.forEach(item => {
          if ((!item.dcName) || (!item.pickupPoint)) {
            returnFlag = false;
          }
        })
      }
      return returnFlag;
    }
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 10px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
